import Vue from 'vue'
import App from './App.vue'
import VueCookie from 'vue-cookie'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'

import './custom.scss'

Vue.config.productionTip = false
Vue.use(VueCookie);
Vue.use(BootstrapVue);

Vue.use(VueAnalytics, {
  id: 'UA-172137407-2'
})

new Vue({
  el: '#app',
  render: h => h(App)
}).$mount('#app')
